export const chartLabelTooltip = (tooltipItem, data) => {
    return tooltipItem.yLabel.toLocaleString() + ' €';
};
